import { BaseModel } from './BaseModel';
import Learner from './Learner';
import Post from './Post';
// import AssessmentSubmission from "./AssessmentSubmission";
import AssessmentEvaluation from './AssessmentEvaluation';
import { EvidenceSubmission } from './EvidenceSubmission';

/**
 * @property {Number} learning_outcome - learning_outcome_id
 * @property {Boolean} pass - if not evaluate by learning outcome send
 * @property {Number} evaluated_user - evaluated_user_id
 * @property {Array.<AssessmentAdditionalEvaluation>} assessment_additional_evaluations
 *
 * @typedef {Object} AssessmentAdditionalEvaluation
 * @property {Number} additional_criterion - additional_criterion_id
 * @property {Boolean} pass
 */

export class PostResponse extends BaseModel {
  static get entity() {
    return 'post-responses';
  }

  static get fk() {
    return 'post_response_id';
  }

  static fields() {
    return {
      id: this.attr(null),
      description: this.attr(null),
      attachments: this.attr(null),
      created_at: this.attr(null),
      updated_at: this.attr(null),
      delete_at: this.attr(null),
      user_id: this.attr(null),
      user: this.belongsTo(Learner, 'user_id'),
      post_id: this.attr(null),
      post: this.belongsTo(Post, 'post_id'),
      evidence_submission_id: this.attr(null),
      evidence_submission: this.belongsTo(EvidenceSubmission, 'evidence_submission_id'),
      assessment_submission: this.attr(null),
      assessment_evaluations: this.hasMany(AssessmentEvaluation, 'post_response'),
      assessment_evaluation_id: this.attr(null),
      assessment_evaluation: this.belongsTo(AssessmentEvaluation, 'assessment_evaluation_id'),
      uploading_upload_ids: this.attr([]),
      error_upload_ids: this.attr([]),
      is_editing: this.boolean(false),
      save_message: this.attr(null)
    };
  }

  static apiConfig = {
    actions: {
      // fetch() {
      //   return this.get(`/post-responses`);
      // },

      fetchById(id) {
        return this.get(`/post-responses/${id}`);
      },

      // createPostResponse(body) {
      //   return this.post(`/post-responses`, body);
      // },

      updatePostResponse(id, body) {
        return this.put(`/post-responses/${id}`, body, { save: false });
      },
      updatePostResponseByAssessor(id, body) {
        return this.put(`/post-responses/${id}/update-by-assessor`, body, { save: false });
      },

      fetchByLearner(userId, postId) {
        return this.get(`/learner/${userId}/posts/${postId}/post-responses`);
      },

      /**
       * @param {String} description
       * @param {Number} post post_id
       * @param {Number} user user_id
       */
      responseByLearner(body) {
        return this.post(`/post-responses/submission`, body, {
          save: false
        });
      },

      /**
       * @param {String} description
       * @param {Number} post post_id
       * @param {Number} user user_id
       * @param {AssessmentEvaluation} assessment_evaluation
       */
      responseByTeacher(body) {
        return this.post(`/post-responses/evaluation`, body);
      },

      // async fetchLastestAssessmentSubmission(
      //   teacherId,
      //   sectionId = 1,
      //   postId,
      //   statusId,
      //   _limit = 10,
      //   _start = 0
      // ) {
      //   const promise = await this.get(
      //     `/teacher/${teacherId}/sections/${sectionId}/post/${postId}/assessment-submissions`,
      //     {
      //       params: {
      //         statusId,
      //         _limit,
      //         _start,
      //       },
      //       save: false,
      //     }
      //   );

      //   if (promise?.response?.data) {
      //     const { data = [] } = promise.response;

      //     data.forEach(({ learner, post_responses = [] } = {}) => {
      //       if (learner) {
      //         Learner.insert({
      //           data: [learner],
      //         });
      //       }

      //       if (post_responses.length) {
      //         PostResponse.insert({
      //           data: [...post_responses],
      //         });
      //       }
      //     });
      //   }

      //   return promise;
      // },

      fetchInitialResponses(postId, sectionId, learnerId) {
        return this.get(
          `/post/${postId}/sections/${sectionId}/users/${learnerId}/shown-post-responses`
        );
      },

      fetchHiddenResponses(postId, sectionId, learnerId) {
        return this.get(
          `/post/${postId}/sections/${sectionId}/users/${learnerId}/hidden-post-responses`
        );
      },

      comparisonResponses(body) {
        return this.post(`/post-responses/comparison`, body);
      }
    }
  };

  get isNotPassed() {
    return this.assessment_evaluation && this.assessment_evaluation.pass === false;
  }
}

export default PostResponse;
